import { Data } from 'signup-constants/signupData/Data';
import { getCompanySizeOptionFromEmployeesRange } from '../company-info/companySize';
import { getSentryExtra } from '../error/getSentryExtra';
import { LOG } from '../http-complete-verification/handleCompleteVerificationError';
import { EndpointKey } from '../http/EndpointKey';
import { setEndpointTimeCompleted } from '../store/http-responses/action-creators';
import { getEndpointRetries } from '../store/http-responses/selectors';
import { bulkUpdate, bulkUpdateGtkmData, setSignupDataValue } from '../store/signup-data/action-creators';
import { Tracker } from '../store/tracking/action-creators';
import { getGTKMDomainToUse, getGTKMFallbackDomain } from './gtkmDomainUtils';
import { updateStepOrdersAfterGTKMAPIFailure, updateStepOrdersAfterGTKMAPISuccess } from './updateStepOrders';
export const handleGTKMCompanyInfoSuccess = ({
  domain,
  name,
  industry,
  companySizeLowerBracket,
  companySizeUpperBracket,
  isFreeEmailDomain
}, dispatch, getState) => {
  const state = getState();
  dispatch(Tracker.signupInteraction('gtkm-company-info-prefill-success'));
  dispatch(Tracker.signupInteraction('gtkm-company-info-is-freemail', {
    currentValue: isFreeEmailDomain
  }));
  const gtkmDataWithoutDomain = {
    [Data.CompanySize]: companySizeLowerBracket && companySizeUpperBracket ? getCompanySizeOptionFromEmployeesRange({
      min: companySizeLowerBracket,
      max: companySizeUpperBracket
    }) : '',
    [Data.CompanyName]: name || '',
    [Data.Industry]: industry || ''
  };
  const gtkmData = Object.assign({}, gtkmDataWithoutDomain, {
    [Data.CompanyDomain]: domain || ''
  });
  dispatch(bulkUpdateGtkmData(gtkmData));
  dispatch(bulkUpdate(gtkmDataWithoutDomain));
  const retries = getEndpointRetries(state, EndpointKey.GTKMCompanyInfo);
  if (!isFreeEmailDomain && retries < 1) {
    dispatch(setSignupDataValue(Data.CompanyDomain, domain || ''));
  }
  updateStepOrdersAfterGTKMAPISuccess({
    gtkmData,
    dispatch,
    state,
    isFreeEmailDomain
  });
  dispatch(setEndpointTimeCompleted(EndpointKey.GTKMCompanyInfo, new Date()));
};
export const handleGTKMCompanyInfoError = (error, dispatch, getState) => {
  const state = getState();
  dispatch(Tracker.signupInteraction(`gtkm-industry-prefill-${error.status}`));
  dispatch(Tracker.signupInteraction(`gtkm-company-info-prefill-error-${error.status}`));
  const gtkmDomain = getGTKMDomainToUse(state);
  dispatch(bulkUpdateGtkmData({
    [Data.CompanyDomain]: gtkmDomain
  }));
  const retries = getEndpointRetries(state, EndpointKey.GTKMCompanyInfo);
  if (retries < 1) {
    const fallbackDomain = getGTKMFallbackDomain(state);
    dispatch(setSignupDataValue(Data.CompanyDomain, fallbackDomain));
  }
  const gtkmData = {
    [Data.CompanyDomain]: gtkmDomain
  };
  updateStepOrdersAfterGTKMAPIFailure({
    gtkmData,
    dispatch,
    state
  });
  LOG.error('GTKM Company Information Request Failed', {
    extra: Object.assign({}, getSentryExtra(error), {
      gtkmDomain
    })
  });
};